import { render, staticRenderFns } from "./loading1.vue?vue&type=template&id=8b2ee27c&"
import script from "./loading1.vue?vue&type=script&lang=js&"
export * from "./loading1.vue?vue&type=script&lang=js&"
import style0 from "./loading1.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports